import React from 'react';
import '../styles/about.scss';

const Card = (children) => {
  return (
    <div className="cardWrapper">
      <div className="inner">
        {children?.children?.map((element) => {
          return element;
        })}
      </div>
    </div>
  );
};

export default function About() {
  return (
    <div className="aboutWrapper">
      <div data-aos="fade-down-right">
        <Card>
          <div>About myself</div>
          <div>
            <p>
              I am a mechie turned techie. I've been working in this tech
              industry for 2 years now. I wish to pursue and learn different
              tech stacks. By doing so, would like to contribute something in
              return to the society or community, where I'm from.
            </p>
            <p>
              To be precise, Knowledgeable Front End Developer adept at creating
              successful websites that meet customer needs. Specializing in
              collaborating with a focused customers to gather requirements,
              produce plans and improve designs for usability and functionality.
              Fully proficient in JavaScript, React Js and Rest API’s.
            </p>
          </div>
        </Card>
      </div>{' '}
      <div data-aos="zoom-in" className="midCard">
        <Card>
          <div>what do I like the most about software?</div>
          <div>
            <p>
              <b>
                <i>"Theres always room for improvisation."</i>
              </b>
            </p>
          </div>
        </Card>
      </div>{' '}
      <div data-aos="zoom-out-down" className="lastCard">
        <Card>
          <div>What skillsets do I possess?</div>
          <div>
            <p>
              Im fully proficient in Javascript, which makes myself love to code
              in <b>React JS</b>. I have also worked on many react and
              Javascript related libraries, namely, react-router,next.js, react
              storeFront, react-table,material-UI, nodeJs(beginner).
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
